/* tslint:disable */
/* eslint-disable */
// Generated using typescript-generator version 3.2.1263 on 2025-01-22 15:00:23.

export interface BillingAddress {
    addressLine1: string;
    addressLine2: string;
    city: string;
    postalCode: string;
    stateIso: string;
    countryIso: string;
}

export interface CardHolder {
    fullName: string;
    phoneNumber: string;
    personalIdNumber: string;
    dateOfBirth: string;
}

export interface CreditCard {
    number: string;
    expirationMonth: number;
    expirationYear: number;
    holderName: string;
    cvv: string;
    billingAddress: BillingAddress;
}

export interface MoneyTransferClientCommon {
    firstName: string;
    lastName: string;
    city: string;
    countryCode: string;
}

export interface MoneyTransferTransactionCommon {
    fixed: boolean;
    originatingAmount: number;
    originatingCountryCode: string;
    originatingCurrencyCode: string;
    destinationAmount: number;
    destinationCountryCode: string;
    destinationCurrencyCode: string;
    testQuestion: string;
    testAnswer: string;
    purposeOfTransaction: string;
}

export interface PaymentCardIdRequest {
    cardId: string;
}

export interface PaymentCardRequest {
    customer: CardHolder;
    creditCard: CreditCard;
    saveCard: boolean;
}

export interface TransactionSendCardIdRequest {
    txId: string;
    card: PaymentCardIdRequest;
}

export interface TransactionSendCardRequest {
    txId: string;
    card: PaymentCardRequest;
}

export interface UserInfo extends UserData {
    masterAgentName: string;
    currencyCode: string;
    countryCode: string;
}

export interface UserInfoBuilder<C, B> extends UserDataBuilder<C, B> {
}

export interface UserInfoBuilderImpl extends UserInfoBuilder<UserInfo, UserInfoBuilderImpl> {
}

export interface CheckTerminalRequest {
    terminalCertSerialNumber: string;
    cpuNumber: string;
}

export interface CheckTerminalRequestBuilder {
}

export interface ConfirmOTPRequest {
    otpRequestId: string;
    otpCode: string;
}

export interface CreateOTPRequest {
    mobile: string;
    email: string;
}

export interface CreateUserRequest {
    username: string;
    password: string;
    email: string;
    firstName: string;
    lastName: string;
    mobile: string;
    otpRegistrationId: string;
}

export interface UserContactData {
    address1: string;
    address2: string;
    city: string;
    postalCode: string;
    country: string;
    email: string;
    phone: string;
}

export interface UserContactDataBuilder {
}

export interface UserData {
    personalDetails: UserPersonalData;
    userStatus: ResponseCode;
}

export interface UserDataBuilder<C, B> {
}

export interface UserDataBuilderImpl extends UserDataBuilder<UserData, UserDataBuilderImpl> {
}

export interface UserPersonalData {
    firstName: string;
    lastName: string;
    email: string;
    mobile: string;
}

export interface UserPersonalDataBuilder {
}

export interface UserRegistrationConfig {
    selfRegistrationEnabled: boolean;
    otpRequired: boolean;
}

export interface UserRegistrationConfigBuilder {
}

export interface UserRegistrationData {
    firstName: string;
    lastName: string;
    birthDate: string;
    birthPlace: string;
    birthCountryCode: string;
    documentCountryIssuer: string;
    documentTypeCode: string;
    documentIssuer: string;
    documentNumber: string;
    documentDateOfIssue: string;
    personalId: string;
    documentExpirationDate: string;
    noExpirationDate: boolean;
    citizenship: string;
}

export interface UserRegistrationDataBuilder {
}

export type Mono<T> = T & {
}

export interface WebResponseEntity<T> {
    result: T; problemResponseData?: ProblemResponseData|null;
}

export interface TransactionSendResponse {
    txId: string;
    referenceNumber: string;
    status: ResponseStatus;
    redirectionUrl: string;
}

export interface WebBooleanResponse {
    result: boolean; problemResponseData?: ProblemResponseData|null;
}

export interface ClientPermission {
    subservices: string[];
    permissions: { [index: string]: string[] };
}

export interface WebListResponseEntity<T> {
    result: T[]; problemResponseData?: ProblemResponseData|null;
}

export interface ResponseEntity<T> {
    result: T;
    problemResponseData?: ProblemResponseData|null;
}

export interface WebResponseObject<T> extends WebResponseBase {
    result: T;
}

export interface CorePublisher<T> extends Publisher<T> {
}

export interface ProblemResponseData extends Serializable {
    error: boolean;
    problems: ProblemBase[];
}

export interface WebResponseBase extends Serializable {
    problemResponseData: ProblemResponseData;
}

export interface HttpEntity<T> {
    headers: { [index: string]: string[] };
    body: T;
}

export interface ProblemBase extends Serializable {
    problemCode: number;
    applicationOrigin: string;
    exceptionCode: string;
    message: string;
    details: string;
    type: string;
}

export interface Serializable {
}

export interface Publisher<T> {
}

export interface HttpClient<O> {

    request<R>(requestConfig: { method: string; url: string; queryParams?: any; data?: any; copyFn?: (data: R) => R; options?: O; }): RestResponse<R>;
}

export class RestApplicationClient<O> {

    constructor(protected httpClient: HttpClient<O>) {
    }

    /**
     * HTTP GET /app/check-auth
     * Java method: com.europoint.gatewayshared.controller.ApplicationController.checkAuth
     */
    checkAuth(options?: O): RestResponse<Mono<WebBooleanResponse>> {
        return this.httpClient.request({ method: "GET", url: uriEncoding`app/check-auth`, options: options });
    }

    /**
     * HTTP GET /app/client-permission
     * Java method: com.europoint.gatewayshared.controller.ApplicationController.getClientPermission
     */
    getClientPermission(options?: O): RestResponse<Mono<WebResponseEntity<ClientPermission>>> {
        return this.httpClient.request({ method: "GET", url: uriEncoding`app/client-permission`, options: options });
    }

    /**
     * HTTP GET /app/languages
     * Java method: com.europoint.gatewayshared.controller.ApplicationController.getUsersLanguages
     */
    getUsersLanguages(options?: O): RestResponse<Mono<WebListResponseEntity<string>>> {
        return this.httpClient.request({ method: "GET", url: uriEncoding`app/languages`, options: options });
    }

    /**
     * HTTP GET /app/login
     * Java method: com.europoint.gatewayshared.controller.ApplicationController.login
     */
    login(queryParams?: { terminalSerialNumber?: string; cpuNumber?: string; externalTerminalId?: string; }, options?: O): RestResponse<Mono<void>> {
        return this.httpClient.request({ method: "GET", url: uriEncoding`app/login`, queryParams: queryParams, options: options });
    }

    /**
     * HTTP GET /app/user-data
     * Java method: com.europoint.gatewayshared.controller.ApplicationController.getUserPersonalData
     */
    getUserPersonalData(options?: O): RestResponse<Mono<WebResponseEntity<UserData>>> {
        return this.httpClient.request({ method: "GET", url: uriEncoding`app/user-data`, options: options });
    }

    /**
     * HTTP GET /net-pay-card-confirmation/do
     * Java method: com.europoint.gateway.direct.money.controllers.OpenTransactionController.doCardConfirmation
     */
    doCardConfirmation(queryParams: { Reply: string; TransID: string; Date: string; Order: string; Amount: string; Payments: string; Currency: string; ConfirmationNum: string; Comment: string; ReplyDesc: string; CCType: string; Last4: string; }, options?: O): RestResponse<Mono<void>> {
        return this.httpClient.request({ method: "GET", url: uriEncoding`net-pay-card-confirmation/do`, queryParams: queryParams, options: options });
    }

    /**
     * HTTP POST /registration/confirm-otp
     * Java method: com.europoint.gatewayshared.controller.RegistrationController.confirmOtp
     */
    confirmOtp(confirmOTPRequest: ConfirmOTPRequest, options?: O): RestResponse<Mono<ResponseEntity<string>>> {
        return this.httpClient.request({ method: "POST", url: uriEncoding`registration/confirm-otp`, data: confirmOTPRequest, options: options });
    }

    /**
     * HTTP POST /registration/create-otp
     * Java method: com.europoint.gatewayshared.controller.RegistrationController.createOtp
     */
    createOtp(createUser: CreateOTPRequest, options?: O): RestResponse<Mono<ResponseEntity<string>>> {
        return this.httpClient.request({ method: "POST", url: uriEncoding`registration/create-otp`, data: createUser, options: options });
    }

    /**
     * HTTP POST /registration/create-user
     * Java method: com.europoint.gatewayshared.controller.RegistrationController.createUser
     */
    createUser(createUserRequest: CreateUserRequest, options?: O): RestResponse<Mono<ResponseEntity<string>>> {
        return this.httpClient.request({ method: "POST", url: uriEncoding`registration/create-user`, data: createUserRequest, options: options });
    }

    /**
     * HTTP GET /registration/selfregistration-config
     * Java method: com.europoint.gatewayshared.controller.RegistrationController.getSelfRegistrationConfig
     */
    getSelfRegistrationConfig(options?: O): RestResponse<Mono<ResponseEntity<UserRegistrationConfig>>> {
        return this.httpClient.request({ method: "GET", url: uriEncoding`registration/selfregistration-config`, options: options });
    }

    /**
     * HTTP POST /transaction/send-card
     * Java method: com.europoint.gateway.direct.money.controllers.TransactionController.sendTransactionWithCard
     */
    sendTransactionWithCard(request: TransactionSendCardRequest, options?: O): RestResponse<Mono<WebResponseEntity<TransactionSendResponse>>> {
        return this.httpClient.request({ method: "POST", url: uriEncoding`transaction/send-card`, data: request, options: options });
    }

    /**
     * HTTP POST /transaction/send-card-id
     * Java method: com.europoint.gateway.direct.money.controllers.TransactionController.sendTransactionWithCardId
     */
    sendTransactionWithCardId(request: TransactionSendCardIdRequest, options?: O): RestResponse<Mono<WebResponseEntity<TransactionSendResponse>>> {
        return this.httpClient.request({ method: "POST", url: uriEncoding`transaction/send-card-id`, data: request, options: options });
    }

    /**
     * HTTP GET /user/info
     * Java method: com.europoint.gateway.direct.money.controllers.UserController.getUserInfo
     */
    getUserInfo(options?: O): RestResponse<Mono<WebResponseEntity<UserInfo>>> {
        return this.httpClient.request({ method: "GET", url: uriEncoding`user/info`, options: options });
    }
}

export type RestResponse<R> = Promise<Axios.GenericAxiosResponse<R>>;

export const enum ResponseCode {
    OK = "OK",
    LoginOtpExpired = "LoginOtpExpired",
    LoginOtpFailed = "LoginOtpFailed",
    ApplicationPermissionRequired = "ApplicationPermissionRequired",
    PersonRegistrationRequired = "PersonRegistrationRequired",
    AgentUserError = "AgentUserError",
    Error = "Error",
}

/**
 * Values:
 * - `CONTINUE`
 * - `SWITCHING_PROTOCOLS`
 * - `PROCESSING`
 * - `CHECKPOINT`
 * - `OK`
 * - `CREATED`
 * - `ACCEPTED`
 * - `NON_AUTHORITATIVE_INFORMATION`
 * - `NO_CONTENT`
 * - `RESET_CONTENT`
 * - `PARTIAL_CONTENT`
 * - `MULTI_STATUS`
 * - `ALREADY_REPORTED`
 * - `IM_USED`
 * - `MULTIPLE_CHOICES`
 * - `MOVED_PERMANENTLY`
 * - `FOUND`
 * - `MOVED_TEMPORARILY` - @deprecated
 * - `SEE_OTHER`
 * - `NOT_MODIFIED`
 * - `USE_PROXY` - @deprecated
 * - `TEMPORARY_REDIRECT`
 * - `PERMANENT_REDIRECT`
 * - `BAD_REQUEST`
 * - `UNAUTHORIZED`
 * - `PAYMENT_REQUIRED`
 * - `FORBIDDEN`
 * - `NOT_FOUND`
 * - `METHOD_NOT_ALLOWED`
 * - `NOT_ACCEPTABLE`
 * - `PROXY_AUTHENTICATION_REQUIRED`
 * - `REQUEST_TIMEOUT`
 * - `CONFLICT`
 * - `GONE`
 * - `LENGTH_REQUIRED`
 * - `PRECONDITION_FAILED`
 * - `PAYLOAD_TOO_LARGE`
 * - `REQUEST_ENTITY_TOO_LARGE` - @deprecated
 * - `URI_TOO_LONG`
 * - `REQUEST_URI_TOO_LONG` - @deprecated
 * - `UNSUPPORTED_MEDIA_TYPE`
 * - `REQUESTED_RANGE_NOT_SATISFIABLE`
 * - `EXPECTATION_FAILED`
 * - `I_AM_A_TEAPOT`
 * - `INSUFFICIENT_SPACE_ON_RESOURCE` - @deprecated
 * - `METHOD_FAILURE` - @deprecated
 * - `DESTINATION_LOCKED` - @deprecated
 * - `UNPROCESSABLE_ENTITY`
 * - `LOCKED`
 * - `FAILED_DEPENDENCY`
 * - `TOO_EARLY`
 * - `UPGRADE_REQUIRED`
 * - `PRECONDITION_REQUIRED`
 * - `TOO_MANY_REQUESTS`
 * - `REQUEST_HEADER_FIELDS_TOO_LARGE`
 * - `UNAVAILABLE_FOR_LEGAL_REASONS`
 * - `INTERNAL_SERVER_ERROR`
 * - `NOT_IMPLEMENTED`
 * - `BAD_GATEWAY`
 * - `SERVICE_UNAVAILABLE`
 * - `GATEWAY_TIMEOUT`
 * - `HTTP_VERSION_NOT_SUPPORTED`
 * - `VARIANT_ALSO_NEGOTIATES`
 * - `INSUFFICIENT_STORAGE`
 * - `LOOP_DETECTED`
 * - `BANDWIDTH_LIMIT_EXCEEDED`
 * - `NOT_EXTENDED`
 * - `NETWORK_AUTHENTICATION_REQUIRED`
 */
export const enum HttpStatus {
    CONTINUE = "CONTINUE",
    SWITCHING_PROTOCOLS = "SWITCHING_PROTOCOLS",
    PROCESSING = "PROCESSING",
    CHECKPOINT = "CHECKPOINT",
    OK = "OK",
    CREATED = "CREATED",
    ACCEPTED = "ACCEPTED",
    NON_AUTHORITATIVE_INFORMATION = "NON_AUTHORITATIVE_INFORMATION",
    NO_CONTENT = "NO_CONTENT",
    RESET_CONTENT = "RESET_CONTENT",
    PARTIAL_CONTENT = "PARTIAL_CONTENT",
    MULTI_STATUS = "MULTI_STATUS",
    ALREADY_REPORTED = "ALREADY_REPORTED",
    IM_USED = "IM_USED",
    MULTIPLE_CHOICES = "MULTIPLE_CHOICES",
    MOVED_PERMANENTLY = "MOVED_PERMANENTLY",
    FOUND = "FOUND",
    /**
     * @deprecated
     */
    MOVED_TEMPORARILY = "MOVED_TEMPORARILY",
    SEE_OTHER = "SEE_OTHER",
    NOT_MODIFIED = "NOT_MODIFIED",
    /**
     * @deprecated
     */
    USE_PROXY = "USE_PROXY",
    TEMPORARY_REDIRECT = "TEMPORARY_REDIRECT",
    PERMANENT_REDIRECT = "PERMANENT_REDIRECT",
    BAD_REQUEST = "BAD_REQUEST",
    UNAUTHORIZED = "UNAUTHORIZED",
    PAYMENT_REQUIRED = "PAYMENT_REQUIRED",
    FORBIDDEN = "FORBIDDEN",
    NOT_FOUND = "NOT_FOUND",
    METHOD_NOT_ALLOWED = "METHOD_NOT_ALLOWED",
    NOT_ACCEPTABLE = "NOT_ACCEPTABLE",
    PROXY_AUTHENTICATION_REQUIRED = "PROXY_AUTHENTICATION_REQUIRED",
    REQUEST_TIMEOUT = "REQUEST_TIMEOUT",
    CONFLICT = "CONFLICT",
    GONE = "GONE",
    LENGTH_REQUIRED = "LENGTH_REQUIRED",
    PRECONDITION_FAILED = "PRECONDITION_FAILED",
    PAYLOAD_TOO_LARGE = "PAYLOAD_TOO_LARGE",
    /**
     * @deprecated
     */
    REQUEST_ENTITY_TOO_LARGE = "REQUEST_ENTITY_TOO_LARGE",
    URI_TOO_LONG = "URI_TOO_LONG",
    /**
     * @deprecated
     */
    REQUEST_URI_TOO_LONG = "REQUEST_URI_TOO_LONG",
    UNSUPPORTED_MEDIA_TYPE = "UNSUPPORTED_MEDIA_TYPE",
    REQUESTED_RANGE_NOT_SATISFIABLE = "REQUESTED_RANGE_NOT_SATISFIABLE",
    EXPECTATION_FAILED = "EXPECTATION_FAILED",
    I_AM_A_TEAPOT = "I_AM_A_TEAPOT",
    /**
     * @deprecated
     */
    INSUFFICIENT_SPACE_ON_RESOURCE = "INSUFFICIENT_SPACE_ON_RESOURCE",
    /**
     * @deprecated
     */
    METHOD_FAILURE = "METHOD_FAILURE",
    /**
     * @deprecated
     */
    DESTINATION_LOCKED = "DESTINATION_LOCKED",
    UNPROCESSABLE_ENTITY = "UNPROCESSABLE_ENTITY",
    LOCKED = "LOCKED",
    FAILED_DEPENDENCY = "FAILED_DEPENDENCY",
    TOO_EARLY = "TOO_EARLY",
    UPGRADE_REQUIRED = "UPGRADE_REQUIRED",
    PRECONDITION_REQUIRED = "PRECONDITION_REQUIRED",
    TOO_MANY_REQUESTS = "TOO_MANY_REQUESTS",
    REQUEST_HEADER_FIELDS_TOO_LARGE = "REQUEST_HEADER_FIELDS_TOO_LARGE",
    UNAVAILABLE_FOR_LEGAL_REASONS = "UNAVAILABLE_FOR_LEGAL_REASONS",
    INTERNAL_SERVER_ERROR = "INTERNAL_SERVER_ERROR",
    NOT_IMPLEMENTED = "NOT_IMPLEMENTED",
    BAD_GATEWAY = "BAD_GATEWAY",
    SERVICE_UNAVAILABLE = "SERVICE_UNAVAILABLE",
    GATEWAY_TIMEOUT = "GATEWAY_TIMEOUT",
    HTTP_VERSION_NOT_SUPPORTED = "HTTP_VERSION_NOT_SUPPORTED",
    VARIANT_ALSO_NEGOTIATES = "VARIANT_ALSO_NEGOTIATES",
    INSUFFICIENT_STORAGE = "INSUFFICIENT_STORAGE",
    LOOP_DETECTED = "LOOP_DETECTED",
    BANDWIDTH_LIMIT_EXCEEDED = "BANDWIDTH_LIMIT_EXCEEDED",
    NOT_EXTENDED = "NOT_EXTENDED",
    NETWORK_AUTHENTICATION_REQUIRED = "NETWORK_AUTHENTICATION_REQUIRED",
}

export const enum ResponseStatus {
    TxApproved = "TxApproved",
    TxRejected = "TxRejected",
    TxSuspended = "TxSuspended",
    TxTimeout = "TxTimeout",
    PaymentDeclined = "PaymentDeclined",
    PaymentPending = "PaymentPending",
    PaymentTimeout = "PaymentTimeout",
}

function uriEncoding(template: TemplateStringsArray, ...substitutions: any[]): string {
    let result = "";
    for (let i = 0; i < substitutions.length; i++) {
        result += template[i];
        result += encodeURIComponent(substitutions[i]);
    }
    result += template[template.length - 1];
    return result;
}


// Added by 'AxiosClientExtension' extension

import axios from "axios";
import * as Axios from "axios";

declare module "axios" {
    export interface GenericAxiosResponse<R> extends Axios.AxiosResponse {
        data: R;
    }
}

class AxiosHttpClient implements HttpClient<Axios.AxiosRequestConfig> {

    constructor(private axios: Axios.AxiosInstance) {
    }

    request<R>(requestConfig: { method: string; url: string; queryParams?: any; data?: any; copyFn?: (data: R) => R; options?: Axios.AxiosRequestConfig; }): RestResponse<R> {
        function assign(target: any, source?: any) {
            if (source != undefined) {
                for (const key in source) {
                    if (source.hasOwnProperty(key)) {
                        target[key] = source[key];
                    }
                }
            }
            return target;
        }

        const config: Axios.AxiosRequestConfig = {};
        config.method = requestConfig.method as typeof config.method;  // `string` in axios 0.16.0, `Method` in axios 0.19.0
        config.url = requestConfig.url;
        config.params = requestConfig.queryParams;
        config.data = requestConfig.data;
        assign(config, requestConfig.options);
        const copyFn = requestConfig.copyFn;

        const axiosResponse = this.axios.request(config);
        return axiosResponse.then(axiosResponse => {
            if (copyFn && axiosResponse.data) {
                (axiosResponse as any).originalData = axiosResponse.data;
                axiosResponse.data = copyFn(axiosResponse.data);
            }
            return axiosResponse;
        });
    }
}

export class AxiosRestApplicationClient extends RestApplicationClient<Axios.AxiosRequestConfig> {

    constructor(baseURL: string, axiosInstance: Axios.AxiosInstance = axios.create()) {
        axiosInstance.defaults.baseURL = baseURL;
        super(new AxiosHttpClient(axiosInstance));
    }
}
